import { registerPlugin } from '@capacitor/core'
import type { PermissionState } from '@/composables/usePermissions/types'

interface PermissionResponse {
  state: PermissionState
}

interface IPermissionsPlugin {
  checkContactsPermission(): Promise<PermissionResponse>
  checkMicrophonePermission(): Promise<PermissionResponse>
  checkNotificationsPermission(): Promise<PermissionResponse>

  requestContactsPermission(): Promise<PermissionResponse>
  requestMicrophonePermission(): Promise<PermissionResponse>
  requestNotificationsPermission(): Promise<PermissionResponse>
}

export const PermissionsPlugin = registerPlugin<IPermissionsPlugin>(
  'EmissaryPermissions'
)
